export { default as routes } from './auth.routes'
export { default as vuex } from './auth.store'
